import React, { FC } from 'react'
import { IImageTickerItem } from '../../types'
import Image from '../Image/Image'

export const ImageTickerItem: FC<{
  img: IImageTickerItem
  width?: number
  height?: number
}> = ({ img, width, height }) => {
  return (
    <>
      {img?.link ? (
        <a href={img.link} target="_blank" rel="noreferrer">
          <Image
            src={img.img}
            priority
            width={width || 210}
            height={height || 54}
            objectFit="contain"
          />
        </a>
      ) : (
        <Image
          src={img.img}
          priority
          width={width || 210}
          height={height || 54}
          objectFit="contain"
        />
      )}
    </>
  )
}
